import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { Language } from '../../models/languages/language.model';
import { ApiLanguagesService } from './api/api-languages.service';
import { ApplicationsService } from '../applications/applications.service';

@Injectable({
  providedIn: 'root'
})
export class LanguagesService {

  public languagesLoadedSubject = new Subject<void>();
  public languages: Language[] = [];
  public isLoaded: boolean = false;

  constructor(
    private apiLanguagesService: ApiLanguagesService,
    private applicationsService: ApplicationsService
  ) {
    this.applicationsService.applicationIdSelectedSubject.subscribe(() => {
      this.loadLanguages();
    });

    if (this.applicationsService.applicationIdSelected !== 0) {
      this.loadLanguages();
    }
  }

  private loadLanguages(): void {
    this.isLoaded = false;
    this.apiLanguagesService.getLanguages().then(
      response => {
        this.languages = response.results;
        this.isLoaded = true;
        this.languagesLoadedSubject.next();
      },
      error => { console.error('Failed to load languages', error); }
    );
  }
}
